module.exports = __webpack_public_path__ + "img/172.aae3d358.jpg";